import React from 'react';
import './page.scss';

/**
 * SplashScreen component to display while the app is loading or working.
 * @param {Object} props
 * @param {string} [props.message] - Optional message to display below the spinner.
 */
const SplashScreen = ({ message }) => {
  return (
    <div className="SplashScreen">
      <div className="wave-container">
        <svg className="waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
          <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
          </defs>
          <g className="parallax">
            <use href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.07)" />
            <use href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.1)" />
            <use href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.13)" />
            <use href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,0.2)" />
          </g>
        </svg>
      </div>

      <div className="splash-content">
        <div className="logo-container">
          <img src="/IMG/logoletras.svg" alt="Symphony Logo" className="splash-logo" />
        </div>
        <div className="message-container">
          {message && <p className="splash-message">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;